var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 42,
    viewBox: "0 0 88 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18 47L-14.2333 46.4423C-10.4667 45.8845 -2.93333 44.7691 4.6 35.7376C12.1333 26.7061 19.6667 9.75866 27.2 7.17644C34.7333 4.59422 42.2667 16.3773 49.8 22.6558C57.3333 28.9344 64.8667 29.7085 72.4 25.3485C79.9333 20.9884 87.4667 11.4942 91.2333 6.74711L95 2",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame3.f6b9f2e8e686b40e749ce30453733546.svg";
export { ForwardRef as ReactComponent };